import q1_img1 from "../images/help/q1_img1.png"
import q1_img2 from "../images/help/q1_img2.png"
import q1_img3 from "../images/help/q1_img3.png"
import q1_img4 from "../images/help/q1_img4.png"
import q1_img5 from "../images/help/q1_img5.png"
import q1_img6 from "../images/help/q1_img6.png"
import q1_img7 from "../images/help/q1_img7.png"
import q2_img1 from "../images/help/q2_img1.png"
import q2_img2 from "../images/help/q2_img2.png"
import q2_img3 from "../images/help/q2_img3.png"
import q2_img4 from "../images/help/q2_img4.png"
import q2_img5 from "../images/help/q2_img5.png"
import q2_img6 from "../images/help/q2_img6.png"
import q2_img7 from "../images/help/q2_img7.png"
import q2_img8 from "../images/help/q2_img8.png"
import q2_img9 from "../images/help/q2_img9.png"
import q2_img10 from "../images/help/q2_img10.png"
import q2_img11 from "../images/help/q2_img11.png"
import q3_img1 from "../images/help/q3_img1.png"
import q3_img2 from "../images/help/q3_img2.jpg"
import q3_img3 from "../images/help/q3_img3.jpg"
import q3_img4 from "../images/help/q3_img4.jpg"
import q3_img5 from "../images/help/q3_img5.png"
import q7_img1 from "../images/help/q7_img1.jpg"
import q8_img1 from "../images/help/q8_img1.jpg"
import q8_img2 from "../images/help/q8_img2.jpg"
import q9_img1 from "../images/help/q9_img1.jpg"
import q9_img2 from "../images/help/q9_img2.png"
import q10_img1 from "../images/help/q10_img1.jpg"
import q10_img2 from "../images/help/q10_img2.jpg"
import q11_img1 from "../images/help/q11_img1.jpg"
import q11_img2 from "../images/help/q11_img2.png"
import q12_img1 from "../images/help/q12_img1.jpg"
import q12_img2 from "../images/help/q12_img2.png"
import q13_img1 from "../images/help/q13_img1.jpg"
import q14_img1 from "../images/help/q14_img1.jpg"

export const faqHelpImages = [
        q1_img1 ,
        q1_img2,
        q1_img3,
        q1_img4,
        q1_img5,
        q1_img6,
        q1_img7,
]
export const faqHelpImagesQ2 = [
    q2_img1,
    q2_img2,
    q2_img3,
    q2_img4,
    q2_img5,
    q2_img6,
    q2_img7,
    q2_img8,
    q2_img9,
    q2_img10,
    q2_img11,
];
export const faqHelpImagesQ3 = [
    q3_img1,
    q3_img2,
    q3_img3,
    q3_img4,
    q3_img5
];

export const faqHelpImagesQ7 = [
    q7_img1,
]

export const faqHelpImagesQ8 = [
    q8_img1,
    q8_img2,
]

export const faqHelpImagesQ9 = [
    q9_img1,
    q9_img2,
]

export const faqHelpImagesQ10 = [
    q10_img1,
    q10_img2
]

export const faqHelpImagesQ11 = [
    q11_img1,
    q11_img2,
]

export const faqHelpImagesQ12 = [
    q12_img1,
    q12_img2,
]

export const faqHelpImagesQ13 = [
    q13_img1,
]

export const faqHelpImagesQ14 = [
    q14_img1,
]